import React, { Component } from "react";
import { observer, inject } from "mobx-react";

class DebugIndex extends Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            loadQuizzer: undefined,
            loadSubject: undefined
        };
    }

    componentDidMount() {
        this.fetchDebug();
    }

    fetchDebug() {
        if (this.props.match.params.quts_id) {
            this.props.rootStore.debugStore.fetchQuts(this.props.match.params.quts_id);
        }
    }

    public render() {
        return (
            <div className="container">
                {JSON.stringify(this.props.rootStore.debugStore.jsonDump)}
            </div>
        );
    }
}

export default observer(DebugIndex);